/** shared score formatting; games import from here so "a game is one folder" still holds for rules */
export function formatTime(ms: number): string {
  const s = Math.floor(ms / 1000);
  const m = Math.floor(s / 60);
  const rest = s % 60;
  const tenths = Math.floor((ms % 1000) / 100);
  return m > 0 ? `${m}:${String(rest).padStart(2, '0')}.${tenths}` : `${rest}.${tenths}s`;
}
